import { ca } from '@cian/analytics';

export function trackActionsMenuClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingSavedSearch',
    action: 'click_menu',
  });
}
